/**
 * TitleAnimationExtension extends the title_animation.js module from Dumbar Components.
 * It listens for all canvasLoaded events on divs with a canvas-wrapper class.
 * When a canvasLoaded event is triggered, it adds an IntersectionObserver to the canvas element,
 * that checks if the canvas is/gets above a third of the viewport.
 * if it does, it triggers the triggerAni() method on the canvas element.
 */
class TitleAnimationExtension {
    constructor() {
        this.$canvasWrappers = document.querySelectorAll('.canvas-wrapper');
        if (!this.$canvasWrappers.length) {
            return;
        }
        this.setupIntersectionObserver();
        this.abortControllers = [];
        this.setupAllTitleAnimations(this.$canvasWrappers);
    }

    canvasLoadedEventHandler(index, event) {
        // when this event is fired, then stop listening to the event on this element
        this.abortControllers[index].abort();

        // get the canvas element from withing the canvas-wrapper element
        const $canvas = event.target.querySelector('canvas');

        // start observing the canvas for it's position in the viewport
        this.observer.observe($canvas);
    }

    setupIntersectionObserver(){
        this.observer = new IntersectionObserver((entry) => {
            entry.forEach((change) => {
                // get the position of the canvas in the viewport
                const positionInViewport = change.rootBounds.y - change.intersectionRect.y;

                // check in what factor of the viewport height the canvas is located (factor === percentage divided by a 100)
                let factor = positionInViewport / change.intersectionRect.height;

                // if the canvas is above a third of the viewport, then trigger the animation
                if (Number.isFinite(factor) && factor <= 0.75 && !isNaN(factor)) {
                    // also unobserve, to clean up memory
                    this.observer.unobserve(change.target);
                    change.target.triggerAni()
                }
            });
        });
    }

    setupAllTitleAnimations($wrappers) {
        $wrappers.forEach(($wrapper, index) => {
            // for each canvas-wrapper element, add an event listener for the canvasLoaded event
            // and store the AbortController in an array, so we can abort the event listener when the canvasLoaded event is fired
            this.abortControllers[index] = new AbortController();
            $wrapper.addEventListener(
                'canvasLoaded',
                this.canvasLoadedEventHandler.bind(this, [index]),
                {signal: this.abortControllers[index].signal}
            );
        });
    }
    static setup() {
        new TitleAnimationExtension();
    }
}

TitleAnimationExtension.setup()
